// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__J-E1x","rotation":"Loader_rotation__lJVTx"};